const fontAwesomeIcons = [
  {
    name: "Glass",
    id: "glass-martini-alt",
    filter: ["martini", "drink", "bar", "alcohol", "liquor"],
    categories: ["Web application icons"],
  },
  {
    name: "Music",
    id: "music",
    filter: ["note", "sound"],
    categories: ["Web application icons"],
  },
  {
    name: "Search",
    id: "search",
    filter: ["magnify", "zoom", "enlarge", "bigger"],
    categories: ["Web application icons"],
  },
  {
    name: "Envelope",
    id: "envelope",
    filter: [
      "email",
      "e-mail",
      "letter",
      "support",
      "mail",
      "message",
      "notification",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Heart",
    id: "heart",
    filter: ["love", "like", "favorite"],
    categories: ["Web application icons", "Medical icons"],
  },
  {
    name: "Star",
    id: "star",
    filter: ["award", "achievement", "night", "rating", "score", "favorite"],
    categories: ["Web application icons"],
  },
  {
    name: "Medal",
    id: "medal",
    filter: ["award", "achievement", "night", "rating", "score", "favorite"],
    categories: ["Web application icons"],
  },
  {
    name: "User",
    id: "user",
    filter: ["person", "man", "head", "profile"],
    categories: ["Web application icons"],
  },
  {
    name: "Film",
    id: "film",
    filter: ["movie"],
    categories: ["Web application icons"],
  },
  {
    name: "Th large",
    id: "th-large",
    filter: ["blocks", "squares", "boxes", "grid"],
    categories: ["Text editor icons"],
  },
  {
    name: "Th",
    id: "th",
    filter: ["blocks", "squares", "boxes", "grid"],
    categories: ["Text editor icons"],
  },
  {
    name: "Th list",
    id: "th-list",
    filter: ["ul", "ol", "checklist", "finished", "completed", "done", "todo"],
    categories: ["Text editor icons"],
  },
  {
    name: "Check",
    id: "check",
    filter: [
      "checkmark",
      "done",
      "todo",
      "agree",
      "accept",
      "confirm",
      "tick",
      "ok",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Times",
    id: "times",
    aliases: ["remove", "close"],
    filter: ["close", "exit", "x", "cross"],
    categories: ["Web application icons"],
  },
  {
    name: "Search plus",
    id: "search-plus",
    filter: ["magnify", "zoom", "enlarge", "bigger"],
    categories: ["Web application icons"],
  },
  {
    name: "Search minus",
    id: "search-minus",
    filter: ["magnify", "minify", "zoom", "smaller"],
    categories: ["Web application icons"],
  },
  {
    name: "Power off",
    id: "power-off",
    filter: ["on"],
    categories: ["Web application icons"],
  },
  {
    name: "Signal",
    id: "signal",
    filter: ["graph", "bars"],
    categories: ["Web application icons"],
  },
  {
    name: "Cog",
    id: "cog",
    filter: ["settings"],
    aliases: ["gear"],
    categories: ["Web application icons", "Spinner icons"],
  },
  {
    name: "Trash",
    id: "trash",
    filter: ["garbage", "delete", "remove", "trash", "hide"],
    categories: ["Web application icons"],
  },
  {
    name: "Home",
    id: "home",
    filter: ["main", "house"],
    categories: ["Web application icons"],
  },
  {
    name: "File outlined",
    id: "file-o",
    filter: ["new", "page", "pdf", "document"],
    categories: ["Text editor icons", "File type icons"],
  },
  {
    name: "Clock",
    id: "clock",
    filter: ["watch", "timer", "late", "timestamp"],
    categories: ["Web application icons"],
  },
  {
    name: "Road",
    id: "road",
    filter: ["street"],
    categories: ["Web application icons"],
  },
  {
    name: "Download",
    id: "download",
    filter: ["import"],
    categories: ["Web application icons"],
  },
  {
    name: "Arrow circle outlined down",
    id: "arrow-circle-o-down",
    filter: ["download"],
    categories: ["Directional icons"],
  },
  {
    name: "Arrow circle outlined up",
    id: "arrow-circle-o-up",
    categories: ["Directional icons"],
  },
  {
    name: "Inbox",
    id: "inbox",
    categories: ["Web application icons"],
  },
  {
    name: "Play circle outlined",
    id: "play-circle-o",
    categories: ["Video player icons"],
  },
  {
    name: "Repeat",
    id: "repeat",
    filter: ["redo", "forward"],
    aliases: ["rotate-right"],
    categories: ["Text editor icons"],
  },
  {
    name: "Refresh",
    id: "sync",
    filter: ["reload", "sync"],
    categories: ["Web application icons", "Spinner icons"],
  },
  {
    name: "List alt",
    id: "list-alt",
    filter: ["ul", "ol", "checklist", "finished", "completed", "done", "todo"],
    categories: ["Text editor icons"],
  },
  {
    name: "Lock",
    id: "lock",
    filter: ["protect", "admin", "security"],
    categories: ["Web application icons"],
  },
  {
    name: "Flag",
    id: "flag",
    filter: ["report", "notification", "notify"],
    categories: ["Web application icons"],
  },
  {
    name: "Headphones",
    id: "headphones",
    filter: ["sound", "listen", "music", "audio"],
    categories: ["Web application icons"],
  },
  {
    name: "Volume off",
    id: "volume-off",
    filter: ["audio", "mute", "sound", "music"],
    categories: ["Web application icons"],
  },
  {
    name: "Volume down",
    id: "volume-down",
    filter: ["audio", "lower", "quieter", "sound", "music"],
    categories: ["Web application icons"],
  },
  {
    name: "Volume up",
    id: "volume-up",
    filter: ["audio", "higher", "louder", "sound", "music"],
    categories: ["Web application icons"],
  },
  {
    name: "Qrcode",
    id: "qrcode",
    filter: ["scan"],
    categories: ["Web application icons"],
  },
  {
    name: "Barcode",
    id: "barcode",
    filter: ["scan"],
    categories: ["Web application icons"],
  },
  {
    name: "Tag",
    id: "tag",
    filter: ["label"],
    categories: ["Web application icons"],
  },
  {
    name: "Tags",
    id: "tags",
    filter: ["labels"],
    categories: ["Web application icons"],
  },
  {
    name: "Book",
    id: "book",
    filter: ["read", "documentation"],
    categories: ["Web application icons"],
  },
  {
    name: "Bookmark",
    id: "bookmark",
    filter: ["save"],
    categories: ["Web application icons"],
  },
  {
    name: "Print",
    id: "print",
    categories: ["Web application icons"],
  },
  {
    name: "Camera",
    id: "camera",
    filter: ["photo", "picture", "record"],
    categories: ["Web application icons"],
  },
  {
    name: "Font",
    id: "font",
    filter: ["text"],
    categories: ["Text editor icons"],
  },
  {
    name: "Bold",
    id: "bold",
    categories: ["Text editor icons"],
  },
  {
    name: "Italic",
    id: "italic",
    filter: ["italics"],
    categories: ["Text editor icons"],
  },
  {
    name: "Text height",
    id: "text-height",
    categories: ["Text editor icons"],
  },
  {
    name: "Text width",
    id: "text-width",
    categories: ["Text editor icons"],
  },
  {
    name: "Align left",
    id: "align-left",
    filter: ["text"],
    categories: ["Text editor icons"],
  },
  {
    name: "Align center",
    id: "align-center",
    filter: ["middle", "text"],
    categories: ["Text editor icons"],
  },
  {
    name: "Align right",
    id: "align-right",
    filter: ["text"],
    categories: ["Text editor icons"],
  },
  {
    name: "Align justify",
    id: "align-justify",
    filter: ["text"],
    categories: ["Text editor icons"],
  },
  {
    name: "List",
    id: "list",
    filter: ["ul", "ol", "checklist", "finished", "completed", "done", "todo"],
    categories: ["Text editor icons"],
  },
  {
    name: "Outdent",
    id: "outdent",
    aliases: ["dedent"],
    categories: ["Text editor icons"],
  },
  {
    name: "Indent",
    id: "indent",
    categories: ["Text editor icons"],
  },
  {
    name: "Video camera",
    id: "video",
    filter: ["film", "movie", "record"],
    categories: ["Web application icons"],
  },
  {
    name: "Picture",
    id: "image",
    aliases: ["photo", "image"],
    categories: ["Web application icons"],
  },
  {
    name: "Pencil",
    id: "pencil-alt",
    filter: ["write", "edit", "update"],
    categories: ["Web application icons"],
  },
  {
    name: "Map marker",
    id: "map-marker",
    filter: [
      "map",
      "pin",
      "location",
      "coordinates",
      "localize",
      "address",
      "travel",
      "where",
      "place",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Adjust",
    id: "adjust",
    filter: ["contrast"],
    categories: ["Web application icons"],
  },
  {
    name: "Tint",
    id: "tint",
    filter: ["raindrop", "waterdrop", "drop", "droplet"],
    categories: ["Web application icons"],
  },
  {
    name: "Pencil square",
    id: "pen-square",
    filter: ["write", "edit", "update"],
    aliases: ["edit"],
    categories: ["Web application icons"],
  },
  {
    name: "Share square",
    id: "share-square",
    filter: ["social", "send", "arrow"],
    categories: ["Web application icons"],
  },
  {
    name: "Check square",
    id: "check-square",
    filter: ["todo", "done", "agree", "accept", "confirm", "ok"],
    categories: ["Web application icons", "Form control icons"],
  },
  {
    name: "Arrows",
    id: "arrows-alt",
    filter: ["move", "reorder", "resize"],
    categories: ["Web application icons", "Directional icons"],
  },
  {
    name: "Step backward",
    id: "step-backward",
    filter: ["rewind", "previous", "beginning", "start", "first"],
    categories: ["Video player icons"],
  },
  {
    name: "Fast backward",
    id: "fast-backward",
    filter: ["rewind", "previous", "beginning", "start", "first"],
    categories: ["Video player icons"],
  },
  {
    name: "Backward",
    id: "backward",
    filter: ["rewind", "previous"],
    categories: ["Video player icons"],
  },
  {
    name: "Play",
    id: "play",
    filter: ["start", "playing", "music", "sound"],
    categories: ["Video player icons"],
  },
  {
    name: "Pause",
    id: "pause",
    filter: ["wait"],
    categories: ["Video player icons"],
  },
  {
    name: "Stop",
    id: "stop",
    filter: ["block", "box", "square"],
    categories: ["Video player icons"],
  },
  {
    name: "Forward",
    id: "forward",
    filter: ["forward", "next"],
    categories: ["Video player icons"],
  },
  {
    name: "Fast forward",
    id: "fast-forward",
    filter: ["next", "end", "last"],
    categories: ["Video player icons"],
  },
  {
    name: "Step forward",
    id: "step-forward",
    filter: ["next", "end", "last"],
    categories: ["Video player icons"],
  },
  {
    name: "Eject",
    id: "eject",
    categories: ["Video player icons"],
  },
  {
    name: "Chevron left",
    id: "chevron-left",
    filter: ["bracket", "previous", "back"],
    categories: ["Directional icons"],
  },
  {
    name: "Chevron right",
    id: "chevron-right",
    filter: ["bracket", "next", "forward"],
    categories: ["Directional icons"],
  },
  {
    name: "Plus circle",
    id: "plus-circle",
    filter: ["add", "new", "create", "expand"],
    categories: ["Web application icons"],
  },
  {
    name: "Minus circle",
    id: "minus-circle",
    filter: ["delete", "remove", "trash", "hide"],
    categories: ["Web application icons"],
  },
  {
    name: "Times circle",
    id: "times-circle",
    filter: ["close", "exit", "x"],
    categories: ["Web application icons"],
  },
  {
    name: "Check circle",
    id: "check-circle",
    filter: ["todo", "done", "agree", "accept", "confirm", "ok"],
    categories: ["Web application icons"],
  },
  {
    name: "Question circle",
    id: "question-circle",
    filter: ["help", "information", "unknown", "support"],
    categories: ["Web application icons"],
  },
  {
    name: "Info circle",
    id: "info-circle",
    filter: ["help", "information", "more", "details"],
    categories: ["Web application icons"],
  },
  {
    name: "Crosshairs",
    id: "crosshairs",
    filter: ["picker"],
    categories: ["Web application icons"],
  },
  {
    name: "Ban",
    id: "ban",
    filter: [
      "delete",
      "remove",
      "trash",
      "hide",
      "block",
      "stop",
      "abort",
      "cancel",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Arrow left",
    id: "arrow-left",
    filter: ["previous", "back"],
    categories: ["Directional icons"],
  },
  {
    name: "Arrow right",
    id: "arrow-right",
    filter: ["next", "forward"],
    categories: ["Directional icons"],
  },
  {
    name: "Arrow up",
    id: "arrow-up",
    categories: ["Directional icons"],
  },
  {
    name: "Arrow down",
    id: "arrow-down",
    filter: ["download"],
    categories: ["Directional icons"],
  },
  {
    name: "Share",
    id: "share",
    aliases: ["mail-forward"],
    categories: ["Web application icons"],
  },
  {
    name: "Expand",
    id: "expand",
    filter: ["enlarge", "bigger", "resize"],
    categories: ["Video player icons"],
  },
  {
    name: "Compress",
    id: "compress",
    filter: ["collapse", "combine", "contract", "merge", "smaller"],
    categories: ["Video player icons"],
  },
  {
    name: "Plus",
    id: "plus",
    filter: ["add", "new", "create", "expand"],
    categories: ["Web application icons"],
  },
  {
    name: "Minus",
    id: "minus",
    filter: ["hide", "minify", "delete", "remove", "trash", "hide", "collapse"],
    categories: ["Web application icons"],
  },
  {
    name: "Asterisk",
    id: "asterisk",
    filter: ["details"],
    categories: ["Web application icons"],
  },
  {
    name: "Exclamation circle",
    id: "exclamation-circle",
    filter: ["warning", "error", "problem", "notification", "alert"],
    categories: ["Web application icons"],
  },
  {
    name: "Gift",
    id: "gift",
    filter: ["present"],
    categories: ["Web application icons"],
  },
  {
    name: "Leaf",
    id: "leaf",
    filter: ["eco", "nature", "plant"],
    categories: ["Web application icons"],
  },
  {
    name: "Fire",
    id: "fire",
    filter: ["flame", "hot", "popular"],
    categories: ["Web application icons"],
  },
  {
    name: "Eye",
    id: "eye",
    filter: ["show", "visible", "views"],
    categories: ["Web application icons"],
  },
  {
    name: "Eye slash",
    id: "eye-slash",
    filter: ["toggle", "show", "hide", "visible", "visiblity", "views"],
    categories: ["Web application icons"],
  },
  {
    name: "Exclamation triangle",
    id: "exclamation-triangle",
    filter: ["warning", "error", "problem", "notification", "alert"],
    aliases: ["warning"],
    categories: ["Web application icons"],
  },
  {
    name: "Plane",
    id: "plane",
    filter: [
      "travel",
      "trip",
      "location",
      "destination",
      "airplane",
      "fly",
      "mode",
    ],
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "Calendar",
    id: "calendar",
    filter: ["date", "time", "when", "event"],
    categories: ["Web application icons"],
  },
  {
    name: "Random",
    id: "random",
    filter: ["sort", "shuffle"],
    categories: ["Web application icons", "Video player icons"],
  },
  {
    name: "Comment",
    id: "comment",
    filter: [
      "speech",
      "notification",
      "note",
      "chat",
      "bubble",
      "feedback",
      "message",
      "texting",
      "sms",
      "conversation",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Magnet",
    id: "magnet",
    categories: ["Web application icons"],
  },
  {
    name: "Chevron up",
    id: "chevron-up",
    categories: ["Directional icons"],
  },
  {
    name: "Chevron down",
    id: "chevron-down",
    categories: ["Directional icons"],
  },
  {
    name: "Retweet",
    id: "retweet",
    filter: ["refresh", "reload", "share"],
    categories: ["Web application icons"],
  },
  {
    name: "Shopping cart",
    id: "shopping-cart",
    filter: ["checkout", "buy", "purchase", "payment"],
    categories: ["Web application icons"],
  },
  {
    name: "Folder",
    id: "folder",
    categories: ["Web application icons"],
  },
  {
    name: "Folder open",
    id: "folder-open",
    categories: ["Web application icons"],
  },
  {
    name: "Arrows vertical",
    id: "arrows-v",
    filter: ["resize"],
    categories: ["Web application icons", "Directional icons"],
  },
  {
    name: "Arrows horizontal",
    id: "arrows-h",
    filter: ["resize"],
    categories: ["Web application icons", "Directional icons"],
  },
  {
    name: "Bar chart",
    id: "bar-chart",
    aliases: ["bar-chart-o"],
    filter: ["graph", "analytics"],
    categories: ["Web application icons", "Chart icons"],
  },
  {
    name: "Twitter square",
    id: "twitter-square",
    filter: ["tweet", "social network"],
    categories: ["Brand icons"],
  },
  {
    name: "Facebook square",
    id: "facebook-square",
    filter: ["social network"],
    categories: ["Brand icons"],
  },
  {
    name: "Camera retro",
    id: "camera-retro",
    filter: ["photo", "picture", "record"],
    categories: ["Web application icons"],
  },
  {
    name: "Key",
    id: "key",
    filter: ["unlock", "password"],
    categories: ["Web application icons"],
  },
  {
    name: "Cogs",
    id: "cogs",
    aliases: ["gears"],
    filter: ["settings"],
    categories: ["Web application icons"],
  },
  {
    name: "Comments",
    id: "comments",
    filter: [
      "speech",
      "notification",
      "note",
      "chat",
      "bubble",
      "feedback",
      "message",
      "texting",
      "sms",
      "conversation",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Thumbs up outlined",
    id: "thumbs-o-up",
    filter: ["like", "approve", "favorite", "agree", "hand"],
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Thumbs down outlined",
    id: "thumbs-o-down",
    filter: ["dislike", "disapprove", "disagree", "hand"],
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Star half",
    id: "star-half",
    filter: ["award", "achievement", "rating", "score"],
    categories: ["Web application icons"],
  },
  {
    name: "Heart outlined",
    id: "heart-o",
    filter: ["love", "like", "favorite"],
    categories: ["Web application icons", "Medical icons"],
  },
  {
    name: "Sign out",
    id: "sign-out",
    filter: ["log out", "logout", "leave", "exit", "arrow"],
    categories: ["Web application icons"],
  },
  {
    name: "Linkedin square",
    id: "linkedin-square",
    categories: ["Brand icons"],
  },
  {
    name: "Thumb tack",
    id: "thumb-tack",
    filter: ["marker", "pin", "location", "coordinates"],
    categories: ["Web application icons"],
  },
  {
    name: "External link",
    id: "external-link",
    filter: ["open", "new"],
    categories: ["Web application icons"],
  },
  {
    name: "Sign in",
    id: "sign-in",
    filter: [
      "enter",
      "join",
      "log in",
      "login",
      "sign up",
      "sign in",
      "signin",
      "signup",
      "arrow",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Trophy",
    id: "trophy",
    filter: ["award", "achievement", "cup", "winner", "game"],
    categories: ["Web application icons"],
  },
  {
    name: "Github square",
    id: "github-square",
    filter: ["octocat"],
    categories: ["Brand icons"],
  },
  {
    name: "Upload",
    id: "upload",
    filter: ["import"],
    categories: ["Web application icons"],
  },
  {
    name: "Lemon outlined",
    id: "lemon-o",
    filter: ["food"],
    categories: ["Web application icons"],
  },
  {
    name: "Phone",
    id: "phone",
    filter: ["call", "voice", "number", "support", "earphone", "telephone"],
    categories: ["Web application icons"],
  },
  {
    name: "Square outlined",
    id: "square-o",
    filter: ["block", "square", "box"],
    categories: ["Web application icons", "Form control icons"],
  },
  {
    name: "Bookmark outlined",
    id: "bookmark-o",
    filter: ["save"],
    categories: ["Web application icons"],
  },
  {
    name: "Phone square",
    id: "phone-square",
    filter: ["call", "voice", "number", "support", "telephone"],
    categories: ["Web application icons"],
  },
  {
    name: "Twitter",
    id: "twitter",
    filter: ["tweet", "social network"],
    categories: ["Brand icons"],
  },
  {
    name: "Facebook",
    id: "facebook",
    aliases: ["facebook-f"],
    filter: ["social network"],
    categories: ["Brand icons"],
  },
  {
    name: "Github",
    id: "github",
    filter: ["octocat"],
    categories: ["Brand icons"],
  },
  {
    name: "Unlock",
    id: "unlock",
    filter: ["protect", "admin", "password", "lock"],
    categories: ["Web application icons"],
  },
  {
    name: "Credit card",
    id: "credit-card",
    filter: ["money", "buy", "debit", "checkout", "purchase", "payment"],
    categories: ["Web application icons", "Payment icons"],
  },
  {
    name: "Rss",
    id: "rss",
    filter: ["blog"],
    aliases: ["feed"],
    categories: ["Web application icons"],
  },
  {
    name: "Hdd",
    id: "hdd-o",
    filter: ["harddrive", "hard drive", "storage", "save"],
    categories: ["Web application icons"],
  },
  {
    name: "Bullhorn",
    id: "bullhorn",
    filter: ["announcement", "share", "broadcast", "louder", "megaphone"],
    categories: ["Web application icons"],
  },
  {
    name: "Bell",
    id: "bell",
    filter: ["alert", "reminder", "notification"],
    categories: ["Web application icons"],
  },
  {
    name: "Certificate",
    id: "certificate",
    filter: ["badge", "star"],
    categories: ["Web application icons"],
  },
  {
    name: "Hand outlined right",
    id: "hand-o-right",
    filter: ["point", "right", "next", "forward", "finger"],
    categories: ["Directional icons", "Hand icons"],
  },
  {
    name: "Hand outlined left",
    id: "hand-o-left",
    filter: ["point", "left", "previous", "back", "finger"],
    categories: ["Directional icons", "Hand icons"],
  },
  {
    name: "Hand outlined up",
    id: "hand-o-up",
    filter: ["point", "finger"],
    categories: ["Directional icons", "Hand icons"],
  },
  {
    name: "Hand outlined down",
    id: "hand-o-down",
    filter: ["point", "finger"],
    categories: ["Directional icons", "Hand icons"],
  },
  {
    name: "Arrow circle left",
    id: "arrow-circle-left",
    filter: ["previous", "back"],
    categories: ["Directional icons"],
  },
  {
    name: "Arrow circle right",
    id: "arrow-circle-right",
    filter: ["next", "forward"],
    categories: ["Directional icons"],
  },
  {
    name: "Arrow circle up",
    id: "arrow-circle-up",
    categories: ["Directional icons"],
  },
  {
    name: "Arrow circle down",
    id: "arrow-circle-down",
    filter: ["download"],
    categories: ["Directional icons"],
  },
  {
    name: "Globe",
    id: "globe",
    filter: [
      "world",
      "planet",
      "map",
      "place",
      "travel",
      "earth",
      "global",
      "translate",
      "all",
      "language",
      "localize",
      "location",
      "coordinates",
      "country",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Wrench",
    id: "wrench",
    filter: ["settings", "fix", "update", "spanner"],
    categories: ["Web application icons"],
  },
  {
    name: "Tasks",
    id: "tasks",
    filter: ["progress", "loading", "downloading", "downloads", "settings"],
    categories: ["Web application icons"],
  },
  {
    name: "Filter",
    id: "filter",
    filter: ["funnel", "options"],
    categories: ["Web application icons"],
  },
  {
    name: "Briefcase",
    id: "briefcase",
    filter: ["work", "business", "office", "luggage", "bag"],
    categories: ["Web application icons"],
  },
  {
    name: "Arrows alt",
    id: "arrows-alt",
    filter: [
      "expand",
      "enlarge",
      "fullscreen",
      "bigger",
      "move",
      "reorder",
      "resize",
      "arrow",
    ],
    categories: ["Video player icons", "Directional icons"],
  },
  {
    name: "Users",
    id: "users",
    filter: ["people", "profiles", "persons"],
    aliases: ["group"],
    categories: ["Web application icons"],
  },
  {
    name: "Link",
    id: "link",
    filter: ["chain"],
    aliases: ["chain"],
    categories: ["Text editor icons"],
  },
  {
    name: "Cloud",
    id: "cloud",
    filter: ["save"],
    categories: ["Web application icons"],
  },
  {
    name: "Flask",
    id: "flask",
    filter: ["science", "beaker", "experimental", "labs"],
    categories: ["Web application icons"],
  },
  {
    name: "Scissors",
    id: "scissors",
    aliases: ["cut"],
    categories: ["Text editor icons"],
  },
  {
    name: "Files outlined",
    id: "files-o",
    filter: ["duplicate", "clone", "copy"],
    aliases: ["copy"],
    categories: ["Text editor icons"],
  },
  {
    name: "Paperclip",
    id: "paperclip",
    filter: ["attachment"],
    categories: ["Text editor icons"],
  },
  {
    name: "Floppy outlined",
    id: "floppy-o",
    aliases: ["save"],
    categories: ["Text editor icons"],
  },
  {
    name: "Square",
    id: "square",
    filter: ["block", "box"],
    categories: ["Web application icons", "Form control icons"],
  },
  {
    name: "Bars",
    id: "bars",
    aliases: ["navicon", "reorder"],
    filter: [
      "menu",
      "drag",
      "reorder",
      "settings",
      "list",
      "ul",
      "ol",
      "checklist",
      "todo",
      "list",
      "hamburger",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "List ul",
    id: "list-ul",
    filter: ["ul", "ol", "checklist", "todo", "list"],
    categories: ["Text editor icons"],
  },
  {
    name: "List ol",
    id: "list-ol",
    filter: ["ul", "ol", "checklist", "list", "todo", "list", "numbers"],
    categories: ["Text editor icons"],
  },
  {
    name: "Strikethrough",
    id: "strikethrough",
    categories: ["Text editor icons"],
  },
  {
    name: "Underline",
    id: "underline",
    categories: ["Text editor icons"],
  },
  {
    name: "Table",
    id: "table",
    filter: ["data", "excel", "spreadsheet"],
    categories: ["Text editor icons"],
  },
  {
    name: "Magic",
    id: "magic",
    filter: ["wizard", "automatic", "autocomplete"],
    categories: ["Web application icons"],
  },
  {
    name: "Truck",
    id: "truck",
    filter: ["shipping"],
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "Pinterest",
    id: "pinterest",
    categories: ["Brand icons"],
  },
  {
    name: "Pinterest square",
    id: "pinterest-square",
    categories: ["Brand icons"],
  },
  {
    name: "Google plus square",
    id: "google-plus-square",
    filter: ["social network"],
    categories: ["Brand icons"],
  },
  {
    name: "Google plus",
    id: "google-plus",
    filter: ["social network"],
    categories: ["Brand icons"],
  },
  {
    name: "Money",
    id: "money",
    filter: ["cash", "money", "buy", "checkout", "purchase", "payment"],
    categories: ["Web application icons", "Currency icons"],
  },
  {
    name: "Caret down",
    id: "caret-down",
    filter: ["more", "dropdown", "menu", "triangle down", "arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Caret up",
    id: "caret-up",
    filter: ["triangle up", "arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Caret left",
    id: "caret-left",
    filter: ["previous", "back", "triangle left", "arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Caret right",
    id: "caret-right",
    filter: ["next", "forward", "triangle right", "arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Columns",
    id: "columns",
    filter: ["split", "panes"],
    categories: ["Text editor icons"],
  },
  {
    name: "Sort",
    id: "sort",
    filter: ["order"],
    aliases: ["unsorted"],
    categories: ["Web application icons"],
  },
  {
    name: "Sort descending",
    id: "sort-desc",
    filter: ["dropdown", "more", "menu", "arrow"],
    aliases: ["sort-down"],
    categories: ["Web application icons"],
  },
  {
    name: "Sort ascending",
    id: "sort-asc",
    aliases: ["sort-up"],
    filter: ["arrow"],
    categories: ["Web application icons"],
  },
  {
    name: "Envelope",
    id: "envelope",
    filter: [
      "email",
      "e-mail",
      "letter",
      "support",
      "mail",
      "message",
      "notification",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Linkedin",
    id: "linkedin",
    categories: ["Brand icons"],
  },
  {
    name: "TikTok",
    id: "tiktok",
    categories: ["Brand icons"],
  },
  {
    name: "Undo",
    id: "undo",
    filter: ["back"],
    aliases: ["rotate-left"],
    categories: ["Text editor icons"],
  },
  {
    name: "Gavel",
    id: "gavel",
    filter: ["judge", "lawyer", "opinion"],
    aliases: ["legal"],
    categories: ["Web application icons"],
  },
  {
    name: "Tachometer",
    id: "tachometer",
    filter: ["speedometer", "fast"],
    aliases: ["dashboard"],
    categories: ["Web application icons"],
  },
  {
    name: "Comment outlined",
    id: "comment-o",
    filter: [
      "speech",
      "notification",
      "note",
      "chat",
      "bubble",
      "feedback",
      "message",
      "texting",
      "sms",
      "conversation",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Comments outlined",
    id: "comments-o",
    filter: [
      "speech",
      "notification",
      "note",
      "chat",
      "bubble",
      "feedback",
      "message",
      "texting",
      "sms",
      "conversation",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Lightning bolt",
    id: "bolt",
    filter: ["lightning", "weather"],
    aliases: ["flash"],
    categories: ["Web application icons"],
  },
  {
    name: "Sitemap",
    id: "sitemap",
    filter: ["directory", "hierarchy", "organization"],
    categories: ["Web application icons"],
  },
  {
    name: "Umbrella",
    id: "umbrella",
    categories: ["Web application icons"],
  },
  {
    name: "Clipboard",
    id: "clipboard",
    filter: ["copy"],
    aliases: ["paste"],
    categories: ["Text editor icons"],
  },
  {
    name: "Lightbulb outlined",
    id: "lightbulb-o",
    filter: ["idea", "inspiration"],
    categories: ["Web application icons"],
  },
  {
    name: "Exchange",
    id: "exchange",
    filter: ["transfer", "arrows", "arrow"],
    categories: ["Web application icons", "Directional icons"],
  },
  {
    name: "Cloud download",
    id: "cloud-download",
    filter: ["import"],
    categories: ["Web application icons"],
  },
  {
    name: "Cloud upload",
    id: "cloud-upload",
    filter: ["import"],
    categories: ["Web application icons"],
  },
  {
    name: "User md",
    id: "user-md",
    filter: ["doctor", "profile", "medical", "nurse"],
    categories: ["Medical icons"],
  },
  {
    name: "Stethoscope",
    id: "stethoscope",
    categories: ["Medical icons"],
  },
  {
    name: "Suitcase",
    id: "suitcase",
    filter: ["trip", "luggage", "travel", "move", "baggage"],
    categories: ["Web application icons"],
  },
  {
    name: "Bell outlined",
    id: "bell-o",
    filter: ["alert", "reminder", "notification"],
    categories: ["Web application icons"],
  },
  {
    name: "Coffee",
    id: "coffee",
    filter: ["morning", "mug", "breakfast", "tea", "drink", "cafe"],
    categories: ["Web application icons"],
  },
  {
    name: "Cutlery",
    id: "cutlery",
    filter: ["food", "restaurant", "spoon", "knife", "dinner", "eat"],
    categories: ["Web application icons"],
  },
  {
    name: "File text outlined",
    id: "file-text-o",
    filter: ["new", "page", "pdf", "document"],
    categories: ["Text editor icons", "File type icons"],
  },
  {
    name: "Building outlined",
    id: "building-o",
    filter: ["work", "business", "apartment", "office", "company"],
    categories: ["Web application icons"],
  },
  {
    name: "Hospital outlined",
    id: "hospital-o",
    filter: ["building"],
    categories: ["Medical icons"],
  },
  {
    name: "Ambulance",
    id: "ambulance",
    filter: ["vehicle", "support", "help"],
    categories: ["Medical icons", "Transportation icons"],
  },
  {
    name: "Medkit",
    id: "medkit",
    filter: ["first aid", "firstaid", "help", "support", "health"],
    categories: ["Medical icons"],
  },
  {
    name: "Fighter jet",
    id: "fighter-jet",
    filter: ["fly", "plane", "airplane", "quick", "fast", "travel"],
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "Beer",
    id: "beer",
    filter: ["alcohol", "stein", "drink", "mug", "bar", "liquor"],
    categories: ["Web application icons"],
  },
  {
    name: "H square",
    id: "h-square",
    filter: ["hospital", "hotel"],
    categories: ["Medical icons"],
  },
  {
    name: "Plus square",
    id: "plus-square",
    filter: ["add", "new", "create", "expand"],
    categories: [
      "Medical icons",
      "Web application icons",
      "Form control icons",
    ],
  },
  {
    name: "Angle double left",
    id: "angle-double-left",
    filter: ["laquo", "quote", "previous", "back", "arrows"],
    categories: ["Directional icons"],
  },
  {
    name: "Angle double right",
    id: "angle-double-right",
    filter: ["raquo", "quote", "next", "forward", "arrows"],
    categories: ["Directional icons"],
  },
  {
    name: "Angle double up",
    id: "angle-double-up",
    filter: ["arrows"],
    categories: ["Directional icons"],
  },
  {
    name: "Angle double down",
    id: "angle-double-down",
    filter: ["arrows"],
    categories: ["Directional icons"],
  },
  {
    name: "Angle left",
    id: "angle-left",
    filter: ["previous", "back", "arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Angle right",
    id: "angle-right",
    filter: ["next", "forward", "arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Angle up",
    id: "angle-up",
    filter: ["arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Angle down",
    id: "angle-down",
    filter: ["arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Desktop",
    id: "desktop",
    filter: ["monitor", "screen", "desktop", "computer", "demo", "device"],
    categories: ["Web application icons"],
  },
  {
    name: "Laptop",
    id: "laptop",
    filter: ["demo", "computer", "device"],
    categories: ["Web application icons"],
  },
  {
    name: "Tablet",
    id: "tablet",
    filter: ["ipad", "device"],
    categories: ["Web application icons"],
  },
  {
    name: "Mobile phone",
    id: "mobile",
    filter: [
      "cell phone",
      "cellphone",
      "text",
      "call",
      "iphone",
      "number",
      "telephone",
    ],
    aliases: ["mobile-phone"],
    categories: ["Web application icons"],
  },
  {
    name: "Circle outlined",
    id: "circle-o",
    categories: ["Web application icons", "Form control icons"],
  },
  {
    name: "Quote left",
    id: "quote-left",
    categories: ["Web application icons"],
  },
  {
    name: "Quote right",
    id: "quote-right",
    categories: ["Web application icons"],
  },
  {
    name: "Spinner",
    id: "spinner",
    filter: ["loading", "progress"],
    categories: ["Web application icons", "Spinner icons"],
  },
  {
    name: "Circle",
    id: "circle",
    filter: ["dot", "notification"],
    categories: ["Web application icons", "Form control icons"],
  },
  {
    name: "Reply",
    id: "reply",
    aliases: ["mail-reply"],
    categories: ["Web application icons"],
  },
  {
    name: "Github alt",
    id: "github-alt",
    filter: ["octocat"],
    categories: ["Brand icons"],
  },
  {
    name: "Folder outlined",
    id: "folder-o",
    categories: ["Web application icons"],
  },
  {
    name: "Folder open outlined",
    id: "folder-open-o",
    categories: ["Web application icons"],
  },
  {
    name: "Smile outlined",
    id: "smile-o",
    filter: ["face", "emoticon", "happy", "approve", "satisfied", "rating"],
    categories: ["Web application icons"],
  },
  {
    name: "Frown outlined",
    id: "frown-o",
    filter: ["face", "emoticon", "sad", "disapprove", "rating"],
    categories: ["Web application icons"],
  },
  {
    name: "Meh outlined",
    id: "meh-o",
    filter: ["face", "emoticon", "rating", "neutral"],
    categories: ["Web application icons"],
  },
  {
    name: "Gamepad",
    id: "gamepad",
    filter: ["controller"],
    categories: ["Web application icons"],
  },
  {
    name: "Keyboard outlined",
    id: "keyboard-o",
    filter: ["type", "input"],
    categories: ["Web application icons"],
  },
  {
    name: "Flag outlined",
    id: "flag-o",
    filter: ["report", "notification"],
    categories: ["Web application icons"],
  },
  {
    name: "Flag checkered",
    id: "flag-checkered",
    filter: ["report", "notification", "notify"],
    categories: ["Web application icons"],
  },
  {
    name: "Terminal",
    id: "terminal",
    filter: ["command", "prompt", "code"],
    categories: ["Web application icons"],
  },
  {
    name: "Code",
    id: "code",
    filter: ["html", "brackets"],
    categories: ["Web application icons"],
  },
  {
    name: "Reply all",
    id: "reply-all",
    aliases: ["mail-reply-all"],
    categories: ["Web application icons"],
  },
  {
    name: "Star half outlined",
    id: "star-half-o",
    filter: ["award", "achievement", "rating", "score"],
    aliases: ["star-half-empty", "star-half-full"],
    categories: ["Web application icons"],
  },
  {
    name: "Location arrow",
    id: "location-arrow",
    filter: ["map", "coordinates", "location", "address", "place", "where"],
    categories: ["Web application icons"],
  },
  {
    name: "Crop",
    id: "crop",
    categories: ["Web application icons"],
  },
  {
    name: "Code fork",
    id: "code-fork",
    filter: [
      "git",
      "fork",
      "vcs",
      "svn",
      "github",
      "rebase",
      "version",
      "merge",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Chain broken",
    id: "chain-broken",
    filter: ["remove"],
    aliases: ["unlink"],
    categories: ["Text editor icons"],
  },
  {
    name: "Question",
    id: "question",
    filter: ["help", "information", "unknown", "support"],
    categories: ["Web application icons"],
  },
  {
    name: "Info",
    id: "info",
    filter: ["help", "information", "more", "details"],
    categories: ["Web application icons"],
  },
  {
    name: "Exclamation",
    id: "exclamation",
    filter: ["warning", "error", "problem", "notification", "notify", "alert"],
    categories: ["Web application icons"],
  },
  {
    name: "Superscript",
    id: "superscript",
    filter: ["exponential"],
    categories: ["Text editor icons"],
  },
  {
    name: "Subscript",
    id: "subscript",
    categories: ["Text editor icons"],
  },
  {
    name: "Eraser",
    id: "eraser",
    filter: ["remove", "delete"],
    categories: ["Text editor icons", "Web application icons"],
  },
  {
    name: "Puzzle piece",
    id: "puzzle-piece",
    filter: ["addon", "add-on", "section"],
    categories: ["Web application icons"],
  },
  {
    name: "Microphone",
    id: "microphone",
    filter: ["record", "voice", "sound"],
    categories: ["Web application icons"],
  },
  {
    name: "Microphone slash",
    id: "microphone-slash",
    filter: ["record", "voice", "sound", "mute"],
    categories: ["Web application icons"],
  },
  {
    name: "Shield",
    id: "shield",
    filter: ["award", "achievement", "security", "winner"],
    categories: ["Web application icons"],
  },
  {
    name: "Calendar outlined",
    id: "calendar-o",
    filter: ["date", "time", "when", "event"],
    categories: ["Web application icons"],
  },
  {
    name: "Fire extinguisher",
    id: "fire-extinguisher",
    categories: ["Web application icons"],
  },
  {
    name: "Rocket",
    id: "rocket",
    filter: ["app"],
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "Maxcdn",
    id: "maxcdn",
    categories: ["Brand icons"],
  },
  {
    name: "Chevron circle left",
    id: "chevron-circle-left",
    filter: ["previous", "back", "arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Chevron circle right",
    id: "chevron-circle-right",
    filter: ["next", "forward", "arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Chevron circle up",
    id: "chevron-circle-up",
    filter: ["arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Chevron circle down",
    id: "chevron-circle-down",
    filter: ["more", "dropdown", "menu", "arrow"],
    categories: ["Directional icons"],
  },
  {
    name: "Html 5 logo",
    id: "html5",
    filter: ["code"],
    categories: ["Brand icons"],
  },
  {
    name: "Css 3 logo",
    id: "css3",
    filter: ["code"],
    categories: ["Brand icons"],
  },
  {
    name: "Anchor",
    id: "anchor",
    filter: ["link"],
    categories: ["Web application icons"],
  },
  {
    name: "Unlock alt",
    id: "unlock-alt",
    filter: ["protect", "admin", "password", "lock"],
    categories: ["Web application icons"],
  },
  {
    name: "Bullseye",
    id: "bullseye",
    filter: ["target"],
    categories: ["Web application icons"],
  },
  {
    name: "Ellipsis horizontal",
    id: "ellipsis-h",
    filter: ["dots"],
    categories: ["Web application icons"],
  },
  {
    name: "Ellipsis vertical",
    id: "ellipsis-v",
    filter: ["dots"],
    categories: ["Web application icons"],
  },
  {
    name: "Rss square",
    id: "rss-square",
    filter: ["feed", "blog"],
    categories: ["Web application icons"],
  },
  {
    name: "Play circle",
    id: "play-circle",
    filter: ["start", "playing"],
    categories: ["Video player icons"],
  },
  {
    name: "Ticket",
    id: "ticket",
    filter: ["movie", "pass", "support"],
    categories: ["Web application icons"],
  },
  {
    name: "Minus square",
    id: "minus-square",
    filter: ["hide", "minify", "delete", "remove", "trash", "hide", "collapse"],
    categories: ["Web application icons", "Form control icons"],
  },
  {
    name: "Minus square outlined",
    id: "minus-square-o",
    filter: ["hide", "minify", "delete", "remove", "trash", "hide", "collapse"],
    categories: ["Web application icons", "Form control icons"],
  },
  {
    name: "Level up",
    id: "level-up",
    filter: ["arrow"],
    categories: ["Web application icons"],
  },
  {
    name: "Level down",
    id: "level-down",
    filter: ["arrow"],
    categories: ["Web application icons"],
  },
  {
    name: "Check square",
    id: "check-square",
    filter: ["checkmark", "done", "todo", "agree", "accept", "confirm", "ok"],
    categories: ["Web application icons", "Form control icons"],
  },
  {
    name: "Pencil square",
    id: "pencil-square",
    filter: ["write", "edit", "update"],
    categories: ["Web application icons"],
  },
  {
    name: "External link square",
    id: "external-link-square",
    filter: ["open", "new"],
    categories: ["Web application icons"],
  },
  {
    name: "Share square",
    id: "share-square",
    filter: ["social", "send"],
    categories: ["Web application icons"],
  },
  {
    name: "Compass",
    id: "compass",
    filter: ["safari", "directory", "menu", "location"],
    categories: ["Web application icons"],
  },
  {
    name: "Caret square outlined down",
    id: "caret-square-o-down",
    aliases: ["toggle-down"],
    filter: ["more", "dropdown", "menu"],
    categories: ["Web application icons", "Directional icons"],
  },
  {
    name: "Caret square outlined up",
    id: "caret-square-o-up",
    aliases: ["toggle-up"],
    categories: ["Web application icons", "Directional icons"],
  },
  {
    name: "Caret square outlined right",
    id: "caret-square-o-right",
    filter: ["next", "forward"],
    aliases: ["toggle-right"],
    categories: ["Web application icons", "Directional icons"],
  },
  {
    name: "Euro (eur)",
    id: "eur",
    aliases: ["euro"],
    categories: ["Currency icons"],
  },
  {
    name: "Gbp",
    id: "gbp",
    categories: ["Currency icons"],
  },
  {
    name: "Us dollar",
    id: "usd",
    aliases: ["dollar"],
    categories: ["Currency icons"],
  },
  {
    name: "Indian rupee (inr)",
    id: "inr",
    aliases: ["rupee"],
    categories: ["Currency icons"],
  },
  {
    name: "Japanese yen (jpy)",
    id: "jpy",
    aliases: ["cny", "rmb", "yen"],
    categories: ["Currency icons"],
  },
  {
    name: "Russian ruble (rub)",
    id: "rub",
    aliases: ["ruble", "rouble"],
    categories: ["Currency icons"],
  },
  {
    name: "Korean won (krw)",
    id: "krw",
    aliases: ["won"],
    categories: ["Currency icons"],
  },
  {
    name: "Bitcoin (btc)",
    id: "btc",
    aliases: ["bitcoin"],
    categories: ["Currency icons", "Brand icons"],
  },
  {
    name: "File",
    id: "file",
    filter: ["new", "page", "pdf", "document"],
    categories: ["Text editor icons", "File type icons"],
  },
  {
    name: "File text",
    id: "file-text",
    filter: ["new", "page", "pdf", "document"],
    categories: ["Text editor icons", "File type icons"],
  },
  {
    name: "Sort alpha ascending",
    id: "sort-alpha-asc",
    categories: ["Web application icons"],
  },
  {
    name: "Sort alpha descending",
    id: "sort-alpha-desc",
    categories: ["Web application icons"],
  },
  {
    name: "Sort amount ascending",
    id: "sort-amount-asc",
    categories: ["Web application icons"],
  },
  {
    name: "Sort amount descending",
    id: "sort-amount-desc",
    categories: ["Web application icons"],
  },
  {
    name: "Sort numeric ascending",
    id: "sort-numeric-asc",
    filter: ["numbers"],
    categories: ["Web application icons"],
  },
  {
    name: "Sort numeric descending",
    id: "sort-numeric-desc",
    filter: ["numbers"],
    categories: ["Web application icons"],
  },
  {
    name: "Thumbs up",
    id: "thumbs-up",
    filter: ["like", "favorite", "approve", "agree", "hand"],
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Thumbs down",
    id: "thumbs-down",
    filter: ["dislike", "disapprove", "disagree", "hand"],
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Youtube square",
    id: "youtube-square",
    filter: ["video", "film"],
    categories: ["Brand icons"],
  },
  {
    name: "Youtube",
    id: "youtube",
    filter: ["video", "film"],
    categories: ["Brand icons"],
  },
  {
    name: "Xing",
    id: "xing",
    categories: ["Brand icons"],
  },
  {
    name: "Xing square",
    id: "xing-square",
    categories: ["Brand icons"],
  },
  {
    name: "Youtube play",
    id: "youtube-play",
    filter: ["start", "playing"],
    categories: ["Brand icons", "Video player icons"],
  },
  {
    name: "Dropbox",
    id: "dropbox",
    categories: ["Brand icons"],
  },
  {
    name: "Stack overflow",
    id: "stack-overflow",
    categories: ["Brand icons"],
  },
  {
    name: "Instagram",
    id: "instagram",
    categories: ["Brand icons"],
  },
  {
    name: "Flickr",
    id: "flickr",
    categories: ["Brand icons"],
  },
  {
    name: "App.net",
    id: "adn",
    categories: ["Brand icons"],
  },
  {
    name: "Bitbucket",
    id: "bitbucket",
    filter: ["git"],
    categories: ["Brand icons"],
  },
  {
    name: "Bitbucket square",
    id: "bitbucket-square",
    filter: ["git"],
    categories: ["Brand icons"],
  },
  {
    name: "Tumblr",
    id: "tumblr",
    categories: ["Brand icons"],
  },
  {
    name: "Tumblr square",
    id: "tumblr-square",
    categories: ["Brand icons"],
  },
  {
    name: "Long arrow down",
    id: "long-arrow-down",
    categories: ["Directional icons"],
  },
  {
    name: "Long arrow up",
    id: "long-arrow-up",
    categories: ["Directional icons"],
  },
  {
    name: "Long arrow left",
    id: "long-arrow-left",
    filter: ["previous", "back"],
    categories: ["Directional icons"],
  },
  {
    name: "Long arrow right",
    id: "long-arrow-right",
    categories: ["Directional icons"],
  },
  {
    name: "Apple",
    id: "apple",
    filter: ["osx", "food"],
    categories: ["Brand icons"],
  },
  {
    name: "Windows",
    id: "windows",
    filter: ["microsoft"],
    categories: ["Brand icons"],
  },
  {
    name: "Android",
    id: "android",
    filter: ["robot"],
    categories: ["Brand icons"],
  },
  {
    name: "Linux",
    id: "linux",
    filter: ["tux"],
    categories: ["Brand icons"],
  },
  {
    name: "Dribbble",
    id: "dribbble",
    categories: ["Brand icons"],
  },
  {
    name: "Skype",
    id: "skype",
    categories: ["Brand icons"],
  },
  {
    name: "Foursquare",
    id: "foursquare",
    categories: ["Brand icons"],
  },
  {
    name: "Trello",
    id: "trello",
    categories: ["Brand icons"],
  },
  {
    name: "Female",
    id: "female",
    filter: ["woman", "user", "person", "profile"],
    categories: ["Web application icons"],
  },
  {
    name: "Male",
    id: "male",
    filter: ["man", "user", "person", "profile"],
    categories: ["Web application icons"],
  },
  {
    name: "Gratipay (gittip)",
    id: "gratipay",
    aliases: ["gittip"],
    filter: ["heart", "like", "favorite", "love"],
    categories: ["Brand icons"],
  },
  {
    name: "Sun outlined",
    id: "sun-o",
    filter: ["weather", "contrast", "lighter", "brighten", "day"],
    categories: ["Web application icons"],
  },
  {
    name: "Moon outlined",
    id: "moon-o",
    filter: ["night", "darker", "contrast"],
    categories: ["Web application icons"],
  },
  {
    name: "Archive",
    id: "archive",
    filter: ["box", "storage"],
    categories: ["Web application icons"],
  },
  {
    name: "Bug",
    id: "bug",
    filter: ["report", "insect"],
    categories: ["Web application icons"],
  },
  {
    name: "Vk",
    id: "vk",
    categories: ["Brand icons"],
  },
  {
    name: "Weibo",
    id: "weibo",
    categories: ["Brand icons"],
  },
  {
    name: "Renren",
    id: "renren",
    categories: ["Brand icons"],
  },
  {
    name: "Pagelines",
    id: "pagelines",
    filter: ["leaf", "leaves", "tree", "plant", "eco", "nature"],
    categories: ["Brand icons"],
  },
  {
    name: "Stack exchange",
    id: "stack-exchange",
    categories: ["Brand icons"],
  },
  {
    name: "Arrow circle outlined right",
    id: "arrow-circle-o-right",
    filter: ["next", "forward"],
    categories: ["Directional icons"],
  },
  {
    name: "Arrow circle outlined left",
    id: "arrow-circle-o-left",
    filter: ["previous", "back"],
    categories: ["Directional icons"],
  },
  {
    name: "Caret square outlined left",
    id: "caret-square-o-left",
    filter: ["previous", "back"],
    aliases: ["toggle-left"],
    categories: ["Web application icons", "Directional icons"],
  },
  {
    name: "Dot circle outlined",
    id: "dot-circle-o",
    filter: ["target", "bullseye", "notification"],
    categories: ["Web application icons", "Form control icons"],
  },
  {
    name: "Wheelchair",
    id: "wheelchair",
    filter: ["handicap", "person"],
    categories: [
      "Web application icons",
      "Medical icons",
      "Transportation icons",
      "Accessibility icons",
    ],
  },
  {
    name: "Vimeo square",
    id: "vimeo-square",
    categories: ["Brand icons"],
  },
  {
    name: "Turkish lira (try)",
    id: "try",
    aliases: ["turkish-lira"],
    categories: ["Currency icons"],
  },
  {
    name: "Plus square outlined",
    id: "plus-square-o",
    filter: ["add", "new", "create", "expand"],
    categories: ["Web application icons", "Form control icons"],
  },
  {
    name: "Space shuttle",
    id: "space-shuttle",
    filter: null,
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "Slack logo",
    id: "slack",
    filter: ["hashtag", "anchor", "hash"],
    categories: ["Brand icons"],
  },
  {
    name: "Envelope square",
    id: "envelope-square",
    filter: [
      "email",
      "e-mail",
      "letter",
      "support",
      "mail",
      "message",
      "notification",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Wordpress logo",
    id: "wordpress",
    categories: ["Brand icons"],
  },
  {
    name: "Openid",
    id: "openid",
    categories: ["Brand icons"],
  },
  {
    name: "University",
    id: "university",
    aliases: ["institution", "bank"],
    categories: ["Web application icons"],
  },
  {
    name: "Graduation cap",
    id: "graduation-cap",
    aliases: ["mortar-board"],
    filter: ["learning", "school", "student"],
    categories: ["Web application icons"],
  },
  {
    name: "Yahoo logo",
    id: "yahoo",
    categories: ["Brand icons"],
  },
  {
    name: "Google logo",
    id: "google",
    categories: ["Brand icons"],
  },
  {
    name: "Reddit logo",
    id: "reddit",
    categories: ["Brand icons"],
  },
  {
    name: "Reddit square",
    id: "reddit-square",
    categories: ["Brand icons"],
  },
  {
    name: "Stumbleupon circle",
    id: "stumbleupon-circle",
    categories: ["Brand icons"],
  },
  {
    name: "Stumbleupon logo",
    id: "stumbleupon",
    categories: ["Brand icons"],
  },
  {
    name: "Delicious logo",
    id: "delicious",
    categories: ["Brand icons"],
  },
  {
    name: "Digg logo",
    id: "digg",
    categories: ["Brand icons"],
  },
  {
    name: "Pied piper pp logo (old)",
    id: "pied-piper-pp",
    categories: ["Brand icons"],
  },
  {
    name: "Pied piper alternate logo",
    id: "pied-piper-alt",
    categories: ["Brand icons"],
  },
  {
    name: "Drupal logo",
    id: "drupal",
    categories: ["Brand icons"],
  },
  {
    name: "Joomla logo",
    id: "joomla",
    categories: ["Brand icons"],
  },
  {
    name: "Language",
    id: "language",
    categories: ["Web application icons"],
  },
  {
    name: "Fax",
    id: "fax",
    categories: ["Web application icons"],
  },
  {
    name: "Building",
    id: "building",
    filter: ["work", "business", "apartment", "office", "company"],
    categories: ["Web application icons"],
  },
  {
    name: "Child",
    id: "child",
    categories: ["Web application icons"],
  },
  {
    name: "Paw",
    id: "paw",
    filter: ["pet"],
    categories: ["Web application icons"],
  },
  {
    name: "Spoon",
    id: "spoon",
    categories: ["Web application icons"],
  },
  {
    name: "Cube",
    id: "cube",
    categories: ["Web application icons"],
  },
  {
    name: "Cubes",
    id: "cubes",
    categories: ["Web application icons"],
  },
  {
    name: "Behance",
    id: "behance",
    categories: ["Brand icons"],
  },
  {
    name: "Behance square",
    id: "behance-square",
    categories: ["Brand icons"],
  },
  {
    name: "Steam",
    id: "steam",
    categories: ["Brand icons"],
  },
  {
    name: "Steam square",
    id: "steam-square",
    categories: ["Brand icons"],
  },
  {
    name: "Recycle",
    id: "recycle",
    categories: ["Web application icons"],
  },
  {
    name: "Car",
    id: "car",
    aliases: ["automobile"],
    filter: ["vehicle"],
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "Taxi",
    id: "taxi",
    aliases: ["cab"],
    filter: ["vehicle"],
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "Tree",
    id: "tree",
    categories: ["Web application icons"],
  },
  {
    name: "Spotify",
    id: "spotify",
    categories: ["Brand icons"],
  },
  {
    name: "Deviantart",
    id: "deviantart",
    categories: ["Brand icons"],
  },
  {
    name: "Soundcloud",
    id: "soundcloud",
    categories: ["Brand icons"],
  },
  {
    name: "Database",
    id: "database",
    categories: ["Web application icons"],
  },
  {
    name: "Pdf file outlined",
    id: "file-pdf-o",
    categories: ["Web application icons", "File type icons"],
  },
  {
    name: "Word file outlined",
    id: "file-word-o",
    categories: ["Web application icons", "File type icons"],
  },
  {
    name: "Excel file outlined",
    id: "file-excel-o",
    categories: ["Web application icons", "File type icons"],
  },
  {
    name: "Powerpoint file outlined",
    id: "file-powerpoint-o",
    categories: ["Web application icons", "File type icons"],
  },
  {
    name: "Image file outlined",
    id: "file-image-o",
    aliases: ["file-photo-o", "file-picture-o"],
    categories: ["Web application icons", "File type icons"],
  },
  {
    name: "Archive file outlined",
    id: "file-archive-o",
    aliases: ["file-zip-o"],
    categories: ["Web application icons", "File type icons"],
  },
  {
    name: "Audio file outlined",
    id: "file-audio-o",
    aliases: ["file-sound-o"],
    categories: ["Web application icons", "File type icons"],
  },
  {
    name: "Video file outlined",
    id: "file-video-o",
    aliases: ["file-movie-o"],
    categories: ["Web application icons", "File type icons"],
  },
  {
    name: "Code file outlined",
    id: "file-code-o",
    categories: ["Web application icons", "File type icons"],
  },
  {
    name: "Vine",
    id: "vine",
    categories: ["Brand icons"],
  },
  {
    name: "Codepen",
    id: "codepen",
    categories: ["Brand icons"],
  },
  {
    name: "Jsfiddle",
    id: "jsfiddle",
    categories: ["Brand icons"],
  },
  {
    name: "Life ring",
    id: "life-ring",
    aliases: ["life-buoy", "life-saver", "support"],
    categories: ["Web application icons"],
  },
  {
    name: "Circle outlined notched",
    id: "circle-o-notch",
    categories: ["Web application icons", "Spinner icons"],
  },
  {
    name: "Rebel alliance",
    id: "rebel",
    aliases: ["ra", "resistance"],
    categories: ["Brand icons"],
  },
  {
    name: "Galactic empire",
    id: "empire",
    aliases: ["ge"],
    categories: ["Brand icons"],
  },
  {
    name: "Git square",
    id: "git-square",
    categories: ["Brand icons"],
  },
  {
    name: "Git",
    id: "git",
    categories: ["Brand icons"],
  },
  {
    name: "Hacker news",
    id: "hacker-news",
    aliases: ["y-combinator-square", "yc-square"],
    categories: ["Brand icons"],
  },
  {
    name: "Tencent weibo",
    id: "tencent-weibo",
    categories: ["Brand icons"],
  },
  {
    name: "Qq",
    id: "qq",
    categories: ["Brand icons"],
  },
  {
    name: "Weixin (wechat)",
    id: "weixin",
    aliases: ["wechat"],
    categories: ["Brand icons"],
  },
  {
    name: "Paper plane",
    id: "paper-plane",
    aliases: ["send"],
    categories: ["Web application icons"],
  },
  {
    name: "Paper plane outlined",
    id: "paper-plane-o",
    aliases: ["send-o"],
    categories: ["Web application icons"],
  },
  {
    name: "History",
    id: "history",
    categories: ["Web application icons"],
  },
  {
    name: "Circle outlined thin",
    id: "circle-thin",
    categories: ["Web application icons"],
  },
  {
    name: "Header",
    id: "header",
    filter: ["heading"],
    categories: ["Text editor icons"],
  },
  {
    name: "Paragraph",
    id: "paragraph",
    categories: ["Text editor icons"],
  },
  {
    name: "Sliders",
    id: "sliders",
    filter: ["settings"],
    categories: ["Web application icons"],
  },
  {
    name: "Share alt",
    id: "share-alt",
    categories: ["Web application icons", "Brand icons"],
  },
  {
    name: "Share alt square",
    id: "share-alt-square",
    categories: ["Web application icons", "Brand icons"],
  },
  {
    name: "Bomb",
    id: "bomb",
    categories: ["Web application icons"],
  },
  {
    name: "Futbol outlined",
    id: "futbol-o",
    aliases: ["soccer-ball-o"],
    categories: ["Web application icons"],
  },
  {
    name: "Tty",
    id: "tty",
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Binoculars",
    id: "binoculars",
    categories: ["Web application icons"],
  },
  {
    name: "Plug",
    id: "plug",
    filter: ["power", "connect"],
    categories: ["Web application icons"],
  },
  {
    name: "Slideshare",
    id: "slideshare",
    categories: ["Brand icons"],
  },
  {
    name: "Twitch",
    id: "twitch",
    categories: ["Brand icons"],
  },
  {
    name: "Yelp",
    id: "yelp",
    categories: ["Brand icons"],
  },
  {
    name: "Newspaper outlined",
    id: "newspaper-o",
    filter: ["press"],
    categories: ["Web application icons"],
  },
  {
    name: "Wifi",
    id: "wifi",
    categories: ["Web application icons"],
  },
  {
    name: "Calculator",
    id: "calculator",
    categories: ["Web application icons"],
  },
  {
    name: "Paypal",
    id: "paypal",
    categories: ["Brand icons", "Payment icons"],
  },
  {
    name: "Google wallet",
    id: "google-wallet",
    categories: ["Brand icons", "Payment icons"],
  },
  {
    name: "Visa credit card",
    id: "cc-visa",
    categories: ["Brand icons", "Payment icons"],
  },
  {
    name: "Mastercard credit card",
    id: "cc-mastercard",
    categories: ["Brand icons", "Payment icons"],
  },
  {
    name: "Discover credit card",
    id: "cc-discover",
    categories: ["Brand icons", "Payment icons"],
  },
  {
    name: "American express credit card",
    id: "cc-amex",
    filter: ["amex"],
    categories: ["Brand icons", "Payment icons"],
  },
  {
    name: "Paypal credit card",
    id: "cc-paypal",
    categories: ["Brand icons", "Payment icons"],
  },
  {
    name: "Stripe credit card",
    id: "cc-stripe",
    categories: ["Brand icons", "Payment icons"],
  },
  {
    name: "Bell slash",
    id: "bell-slash",
    categories: ["Web application icons"],
  },
  {
    name: "Bell slash outlined",
    id: "bell-slash-o",
    categories: ["Web application icons"],
  },
  {
    name: "Trash",
    id: "trash",
    filter: ["garbage", "delete", "remove", "hide"],
    categories: ["Web application icons"],
  },
  {
    name: "Copyright",
    id: "copyright",
    categories: ["Web application icons"],
  },
  {
    name: "At",
    id: "at",
    categories: ["Web application icons"],
  },
  {
    name: "Eyedropper",
    id: "eyedropper",
    categories: ["Web application icons"],
  },
  {
    name: "Paint brush",
    id: "paint-brush",
    categories: ["Web application icons"],
  },
  {
    name: "Birthday cake",
    id: "birthday-cake",
    categories: ["Web application icons"],
  },
  {
    name: "Area chart",
    id: "area-chart",
    filter: ["graph", "analytics"],
    categories: ["Web application icons", "Chart icons"],
  },
  {
    name: "Pie chart",
    id: "pie-chart",
    filter: ["graph", "analytics"],
    categories: ["Web application icons", "Chart icons"],
  },
  {
    name: "Line chart",
    id: "line-chart",
    filter: ["graph", "analytics"],
    categories: ["Web application icons", "Chart icons"],
  },
  {
    name: "Last.fm",
    id: "lastfm",
    categories: ["Brand icons"],
  },
  {
    name: "Last.fm square",
    id: "lastfm-square",
    categories: ["Brand icons"],
  },
  {
    name: "Toggle off",
    id: "toggle-off",
    categories: ["Web application icons"],
  },
  {
    name: "Toggle on",
    id: "toggle-on",
    categories: ["Web application icons"],
  },
  {
    name: "Bicycle",
    id: "bicycle",
    filter: ["vehicle", "bike"],
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "Bus",
    id: "bus",
    filter: ["vehicle"],
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "Ioxhost",
    id: "ioxhost",
    categories: ["Brand icons"],
  },
  {
    name: "Angellist",
    id: "angellist",
    categories: ["Brand icons"],
  },
  {
    name: "Closed captions",
    id: "cc",
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Shekel (ils)",
    id: "ils",
    aliases: ["shekel", "sheqel"],
    categories: ["Currency icons"],
  },
  {
    name: "Meanpath",
    id: "meanpath",
    categories: ["Brand icons"],
  },
  {
    name: "Buysellads",
    id: "buysellads",
    categories: ["Brand icons"],
  },
  {
    name: "Connect develop",
    id: "connectdevelop",
    categories: ["Brand icons"],
  },
  {
    name: "Dashcube",
    id: "dashcube",
    categories: ["Brand icons"],
  },
  {
    name: "Forumbee",
    id: "forumbee",
    categories: ["Brand icons"],
  },
  {
    name: "Leanpub",
    id: "leanpub",
    categories: ["Brand icons"],
  },
  {
    name: "Sellsy",
    id: "sellsy",
    categories: ["Brand icons"],
  },
  {
    name: "Shirts in bulk",
    id: "shirtsinbulk",
    categories: ["Brand icons"],
  },
  {
    name: "Simplybuilt",
    id: "simplybuilt",
    categories: ["Brand icons"],
  },
  {
    name: "Skyatlas",
    id: "skyatlas",
    categories: ["Brand icons"],
  },
  {
    name: "Add to shopping cart",
    id: "cart-plus",
    filter: ["add", "shopping"],
    categories: ["Web application icons"],
  },
  {
    name: "Shopping cart arrow down",
    id: "cart-arrow-down",
    filter: ["shopping"],
    categories: ["Web application icons"],
  },
  {
    name: "Diamond",
    id: "diamond",
    filter: ["gem", "gemstone"],
    categories: ["Web application icons"],
  },
  {
    name: "Ship",
    id: "ship",
    filter: ["boat", "sea"],
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "User secret",
    id: "user-secret",
    filter: ["whisper", "spy", "incognito", "privacy"],
    categories: ["Web application icons"],
  },
  {
    name: "Motorcycle",
    id: "motorcycle",
    filter: ["vehicle", "bike"],
    categories: ["Web application icons", "Transportation icons"],
  },
  {
    name: "Street view",
    id: "street-view",
    filter: ["map"],
    categories: ["Web application icons"],
  },
  {
    name: "Heartbeat",
    id: "heartbeat",
    filter: ["ekg"],
    categories: ["Web application icons", "Medical icons"],
  },
  {
    name: "Venus",
    id: "venus",
    filter: ["female"],
    categories: ["Gender icons"],
  },
  {
    name: "Mars",
    id: "mars",
    filter: ["male"],
    categories: ["Gender icons"],
  },
  {
    name: "Mercury",
    id: "mercury",
    filter: ["transgender"],
    categories: ["Gender icons"],
  },
  {
    name: "Transgender",
    id: "transgender",
    aliases: ["intersex"],
    categories: ["Gender icons"],
  },
  {
    name: "Transgender alt",
    id: "transgender-alt",
    categories: ["Gender icons"],
  },
  {
    name: "Venus double",
    id: "venus-double",
    categories: ["Gender icons"],
  },
  {
    name: "Mars double",
    id: "mars-double",
    categories: ["Gender icons"],
  },
  {
    name: "Venus mars",
    id: "venus-mars",
    categories: ["Gender icons"],
  },
  {
    name: "Mars stroke",
    id: "mars-stroke",
    categories: ["Gender icons"],
  },
  {
    name: "Mars stroke vertical",
    id: "mars-stroke-v",
    categories: ["Gender icons"],
  },
  {
    name: "Mars stroke horizontal",
    id: "mars-stroke-h",
    categories: ["Gender icons"],
  },
  {
    name: "Neuter",
    id: "neuter",
    categories: ["Gender icons"],
  },
  {
    name: "Genderless",
    id: "genderless",
    categories: ["Gender icons"],
  },
  {
    name: "Facebook official",
    id: "facebook-official",
    categories: ["Brand icons"],
  },
  {
    name: "Pinterest p",
    id: "pinterest-p",
    categories: ["Brand icons"],
  },
  {
    name: "What's App",
    id: "whatsapp",
    categories: ["Brand icons"],
  },
  {
    name: "Server",
    id: "server",
    categories: ["Web application icons"],
  },
  {
    name: "Add user",
    id: "user-plus",
    filter: ["sign up", "signup"],
    categories: ["Web application icons"],
  },
  {
    name: "Remove user",
    id: "user-times",
    categories: ["Web application icons"],
  },
  {
    name: "Bed",
    id: "bed",
    filter: ["travel"],
    aliases: ["hotel"],
    categories: ["Web application icons"],
  },
  {
    name: "Viacoin",
    id: "viacoin",
    categories: ["Brand icons"],
  },
  {
    name: "Train",
    id: "train",
    categories: ["Transportation icons"],
  },
  {
    name: "Subway",
    id: "subway",
    categories: ["Transportation icons"],
  },
  {
    name: "Medium",
    id: "medium",
    categories: ["Brand icons"],
  },
  {
    name: "Y combinator",
    id: "y-combinator",
    aliases: ["yc"],
    categories: ["Brand icons"],
  },
  {
    name: "Optin monster",
    id: "optin-monster",
    categories: ["Brand icons"],
  },
  {
    name: "Opencart",
    id: "opencart",
    categories: ["Brand icons"],
  },
  {
    name: "Expeditedssl",
    id: "expeditedssl",
    categories: ["Brand icons"],
  },
  {
    name: "Battery full",
    id: "battery-full",
    aliases: ["battery-4", "battery"],
    filter: ["power"],
    categories: ["Web application icons"],
  },
  {
    name: "Battery 3/4 full",
    id: "battery-three-quarters",
    aliases: ["battery-3"],
    filter: ["power"],
    categories: ["Web application icons"],
  },
  {
    name: "Battery 1/2 full",
    id: "battery-half",
    aliases: ["battery-2"],
    filter: ["power"],
    categories: ["Web application icons"],
  },
  {
    name: "Battery 1/4 full",
    id: "battery-quarter",
    aliases: ["battery-1"],
    filter: ["power"],
    categories: ["Web application icons"],
  },
  {
    name: "Battery empty",
    id: "battery-empty",
    aliases: ["battery-0"],
    filter: ["power"],
    categories: ["Web application icons"],
  },
  {
    name: "Mouse pointer",
    id: "mouse-pointer",
    categories: ["Web application icons"],
  },
  {
    name: "I beam cursor",
    id: "i-cursor",
    categories: ["Web application icons"],
  },
  {
    name: "Object group",
    id: "object-group",
    categories: ["Web application icons"],
  },
  {
    name: "Object ungroup",
    id: "object-ungroup",
    categories: ["Web application icons"],
  },
  {
    name: "Sticky note",
    id: "sticky-note",
    categories: ["Web application icons"],
  },
  {
    name: "Sticky note outlined",
    id: "sticky-note-o",
    categories: ["Web application icons"],
  },
  {
    name: "Jcb credit card",
    id: "cc-jcb",
    categories: ["Brand icons", "Payment icons"],
  },
  {
    name: "Diner's Club Credit Card",
    id: "cc-diners-club",
    categories: ["Brand icons", "Payment icons"],
  },
  {
    name: "Clone",
    id: "clone",
    filter: ["copy"],
    categories: ["Web application icons"],
  },
  {
    name: "Balance scale",
    id: "balance-scale",
    categories: ["Web application icons"],
  },
  {
    name: "Hourglass outlined",
    id: "hourglass-o",
    categories: ["Web application icons"],
  },
  {
    name: "Hourglass start",
    id: "hourglass-start",
    aliases: ["hourglass-1"],
    categories: ["Web application icons"],
  },
  {
    name: "Hourglass half",
    id: "hourglass-half",
    aliases: ["hourglass-2"],
    categories: ["Web application icons"],
  },
  {
    name: "Hourglass end",
    id: "hourglass-end",
    aliases: ["hourglass-3"],
    categories: ["Web application icons"],
  },
  {
    name: "Hourglass",
    id: "hourglass",
    categories: ["Web application icons"],
  },
  {
    name: "Rock (hand)",
    id: "hand-rock-o",
    aliases: ["hand-grab-o"],
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Paper (hand)",
    id: "hand-paper-o",
    aliases: ["hand-stop-o"],
    filter: ["stop"],
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Scissors (hand)",
    id: "hand-scissors-o",
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Lizard (hand)",
    id: "hand-lizard-o",
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Spock (hand)",
    id: "hand-spock-o",
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Hand pointer",
    id: "hand-pointer-o",
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Hand peace",
    id: "hand-peace-o",
    categories: ["Web application icons", "Hand icons"],
  },
  {
    name: "Trademark",
    id: "trademark",
    categories: ["Web application icons"],
  },
  {
    name: "Registered trademark",
    id: "registered",
    categories: ["Web application icons"],
  },
  {
    name: "Creative commons",
    id: "creative-commons",
    categories: ["Web application icons"],
  },
  {
    name: "Gg currency",
    id: "gg",
    categories: ["Currency icons", "Brand icons"],
  },
  {
    name: "Gg currency circle",
    id: "gg-circle",
    categories: ["Currency icons", "Brand icons"],
  },
  {
    name: "Tripadvisor",
    id: "tripadvisor",
    categories: ["Brand icons"],
  },
  {
    name: "Odnoklassniki",
    id: "odnoklassniki",
    categories: ["Brand icons"],
  },
  {
    name: "Odnoklassniki square",
    id: "odnoklassniki-square",
    categories: ["Brand icons"],
  },
  {
    name: "Get pocket",
    id: "get-pocket",
    categories: ["Brand icons"],
  },
  {
    name: "Wikipedia w",
    id: "wikipedia-w",
    categories: ["Brand icons"],
  },
  {
    name: "Safari",
    id: "safari",
    filter: ["browser"],
    categories: ["Brand icons"],
  },
  {
    name: "Chrome",
    id: "chrome",
    filter: ["browser"],
    categories: ["Brand icons"],
  },
  {
    name: "Firefox",
    id: "firefox",
    filter: ["browser"],
    categories: ["Brand icons"],
  },
  {
    name: "Opera",
    id: "opera",
    categories: ["Brand icons"],
  },
  {
    name: "Internet explorer",
    id: "internet-explorer",
    filter: ["browser", "ie"],
    categories: ["Brand icons"],
  },
  {
    name: "Television",
    id: "television",
    aliases: ["tv"],
    filter: ["display", "computer", "monitor"],
    categories: ["Web application icons"],
  },
  {
    name: "Contao",
    id: "contao",
    categories: ["Brand icons"],
  },
  {
    name: "500px",
    id: "500px",
    categories: ["Brand icons"],
  },
  {
    name: "Amazon",
    id: "amazon",
    categories: ["Brand icons"],
  },
  {
    name: "Calendar plus outlined",
    id: "calendar-plus-o",
    categories: ["Web application icons"],
  },
  {
    name: "Calendar minus outlined",
    id: "calendar-minus-o",
    categories: ["Web application icons"],
  },
  {
    name: "Calendar times outlined",
    id: "calendar-times-o",
    categories: ["Web application icons"],
  },
  {
    name: "Calendar check outlined",
    id: "calendar-check-o",
    filter: ["ok"],
    categories: ["Web application icons"],
  },
  {
    name: "Industry",
    id: "industry",
    filter: ["factory"],
    categories: ["Web application icons"],
  },
  {
    name: "Map pin",
    id: "map-pin",
    categories: ["Web application icons"],
  },
  {
    name: "Map signs",
    id: "map-signs",
    categories: ["Web application icons"],
  },
  {
    name: "Map outlined",
    id: "map-o",
    categories: ["Web application icons"],
  },
  {
    name: "Map",
    id: "map",
    categories: ["Web application icons"],
  },
  {
    name: "Commenting",
    id: "commenting",
    filter: [
      "speech",
      "notification",
      "note",
      "chat",
      "bubble",
      "feedback",
      "message",
      "texting",
      "sms",
      "conversation",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Commenting outlined",
    id: "commenting-o",
    filter: [
      "speech",
      "notification",
      "note",
      "chat",
      "bubble",
      "feedback",
      "message",
      "texting",
      "sms",
      "conversation",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Houzz",
    id: "houzz",
    categories: ["Brand icons"],
  },
  {
    name: "Vimeo",
    id: "vimeo",
    categories: ["Brand icons"],
  },
  {
    name: "Font awesome black tie",
    id: "black-tie",
    categories: ["Brand icons"],
  },
  {
    name: "Fonticons",
    id: "fonticons",
    categories: ["Brand icons"],
  },
  {
    name: "Reddit alien",
    id: "reddit-alien",
    categories: ["Brand icons"],
  },
  {
    name: "Edge browser",
    id: "edge",
    filter: ["browser", "ie"],
    categories: ["Brand icons"],
  },
  {
    name: "Credit card",
    id: "credit-card-alt",
    filter: [
      "money",
      "buy",
      "debit",
      "checkout",
      "purchase",
      "payment",
      "credit card",
    ],
    categories: ["Payment icons", "Web application icons"],
  },
  {
    name: "Codie pie",
    id: "codiepie",
    categories: ["Brand icons"],
  },
  {
    name: "Modx",
    id: "modx",
    categories: ["Brand icons"],
  },
  {
    name: "Fort awesome",
    id: "fort-awesome",
    categories: ["Brand icons"],
  },
  {
    name: "Usb",
    id: "usb",
    categories: ["Brand icons"],
  },
  {
    name: "Product hunt",
    id: "product-hunt",
    categories: ["Brand icons"],
  },
  {
    name: "Mixcloud",
    id: "mixcloud",
    categories: ["Brand icons"],
  },
  {
    name: "Scribd",
    id: "scribd",
    categories: ["Brand icons"],
  },
  {
    name: "Pause circle",
    id: "pause-circle",
    categories: ["Video player icons"],
  },
  {
    name: "Pause circle outlined",
    id: "pause-circle-o",
    categories: ["Video player icons"],
  },
  {
    name: "Stop circle",
    id: "stop-circle",
    categories: ["Video player icons"],
  },
  {
    name: "Stop circle outlined",
    id: "stop-circle-o",
    categories: ["Video player icons"],
  },
  {
    name: "Shopping bag",
    id: "shopping-bag",
    categories: ["Web application icons"],
  },
  {
    name: "Shopping basket",
    id: "shopping-basket",
    categories: ["Web application icons"],
  },
  {
    name: "Hashtag",
    id: "hashtag",
    categories: ["Web application icons"],
  },
  {
    name: "Bluetooth",
    id: "bluetooth",
    categories: ["Web application icons", "Brand icons"],
  },
  {
    name: "Bluetooth",
    id: "bluetooth-b",
    categories: ["Web application icons", "Brand icons"],
  },
  {
    name: "Percent",
    id: "percent",
    categories: ["Web application icons"],
  },
  {
    name: "Gitlab",
    id: "gitlab",
    categories: ["Brand icons"],
  },
  {
    name: "Wpbeginner",
    id: "wpbeginner",
    categories: ["Brand icons"],
  },
  {
    name: "Wpforms",
    id: "wpforms",
    categories: ["Brand icons"],
  },
  {
    name: "Envira gallery",
    id: "envira",
    filter: ["leaf"],
    categories: ["Brand icons"],
  },
  {
    name: "Universal access",
    id: "universal-access",
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Wheelchair alt",
    id: "wheelchair-alt",
    filter: ["handicap", "person"],
    categories: [
      "Web application icons",
      "Medical icons",
      "Transportation icons",
      "Accessibility icons",
    ],
  },
  {
    name: "Question circle outlined",
    id: "question-circle-o",
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Blind",
    id: "blind",
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Audio description",
    id: "audio-description",
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Volume control phone",
    id: "volume-control-phone",
    filter: ["telephone"],
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Braille",
    id: "braille",
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Assistive listening systems",
    id: "assistive-listening-systems",
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "American sign language interpreting",
    id: "american-sign-language-interpreting",
    aliases: ["asl-interpreting"],
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Deaf",
    id: "deaf",
    aliases: ["deafness", "hard-of-hearing"],
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Glide",
    id: "glide",
    categories: ["Brand icons"],
  },
  {
    name: "Glide g",
    id: "glide-g",
    categories: ["Brand icons"],
  },
  {
    name: "Sign language",
    id: "sign-language",
    aliases: ["signing"],
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Low vision",
    id: "low-vision",
    categories: ["Web application icons", "Accessibility icons"],
  },
  {
    name: "Viadeo",
    id: "viadeo",
    categories: ["Brand icons"],
  },
  {
    name: "Viadeo square",
    id: "viadeo-square",
    categories: ["Brand icons"],
  },
  {
    name: "Snapchat",
    id: "snapchat",
    categories: ["Brand icons"],
  },
  {
    name: "Snapchat ghost",
    id: "snapchat-ghost",
    categories: ["Brand icons"],
  },
  {
    name: "Snapchat square",
    id: "snapchat-square",
    categories: ["Brand icons"],
  },
  {
    name: "Pied piper logo",
    id: "pied-piper",
    categories: ["Brand icons"],
  },
  {
    name: "First order",
    id: "first-order",
    categories: ["Brand icons"],
  },
  {
    name: "Yoast",
    id: "yoast",
    categories: ["Brand icons"],
  },
  {
    name: "Themeisle",
    id: "themeisle",
    categories: ["Brand icons"],
  },
  {
    name: "Google plus official",
    id: "google-plus-official",
    aliases: ["google-plus-circle"],
    categories: ["Brand icons"],
  },
  {
    name: "Font awesome",
    id: "font-awesome",
    aliases: ["fa"],
    categories: ["Brand icons"],
  },
  {
    name: "Handshake outlined",
    id: "handshake-o",
    categories: ["Web application icons"],
  },
  {
    name: "Envelope open",
    id: "envelope-open",
    filter: [
      "email",
      "e-mail",
      "letter",
      "support",
      "mail",
      "message",
      "notification",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Envelope open outlined",
    id: "envelope-open-o",
    filter: [
      "email",
      "e-mail",
      "letter",
      "support",
      "mail",
      "message",
      "notification",
    ],
    categories: ["Web application icons"],
  },
  {
    name: "Linode",
    id: "linode",
    categories: ["Brand icons"],
  },
  {
    name: "Address book",
    id: "address-book",
    categories: ["Web application icons"],
  },
  {
    name: "Address book outlined",
    id: "address-book-o",
    categories: ["Web application icons"],
  },
  {
    name: "Address card",
    id: "address-card",
    aliases: ["vcard"],
    categories: ["Web application icons"],
  },
  {
    name: "Address card outlined",
    id: "address-card-o",
    aliases: ["vcard-o"],
    categories: ["Web application icons"],
  },
  {
    name: "User circle",
    id: "user-circle",
    categories: ["Web application icons"],
  },
  {
    name: "User circle outlined",
    id: "user-circle-o",
    categories: ["Web application icons"],
  },
  {
    name: "User outlined",
    id: "user-o",
    categories: ["Web application icons"],
  },
  {
    name: "Identification badge",
    id: "id-badge",
    categories: ["Web application icons"],
  },
  {
    name: "Identification card",
    id: "id-card",
    aliases: ["drivers-license"],
    categories: ["Web application icons"],
  },
  {
    name: "Identification card outlined",
    id: "id-card-o",
    aliases: ["drivers-license-o"],
    categories: ["Web application icons"],
  },
  {
    name: "Quora",
    id: "quora",
    categories: ["Brand icons"],
  },
  {
    name: "Free code camp",
    id: "free-code-camp",
    categories: ["Brand icons"],
  },
  {
    name: "Telegram",
    id: "telegram",
    categories: ["Brand icons"],
  },
  {
    name: "Thermometer full",
    id: "thermometer-full",
    aliases: ["thermometer-4", "thermometer"],
    categories: ["Web application icons"],
  },
  {
    name: "Thermometer 3/4 full",
    id: "thermometer-three-quarters",
    aliases: ["thermometer-3"],
    categories: ["Web application icons"],
  },
  {
    name: "Thermometer 1/2 full",
    id: "thermometer-half",
    aliases: ["thermometer-2"],
    categories: ["Web application icons"],
  },
  {
    name: "Thermometer 1/4 full",
    id: "thermometer-quarter",
    aliases: ["thermometer-1"],
    categories: ["Web application icons"],
  },
  {
    name: "Thermometer empty",
    id: "thermometer-empty",
    aliases: ["thermometer-0"],
    categories: ["Web application icons"],
  },
  {
    name: "Shower",
    id: "shower",
    categories: ["Web application icons"],
  },
  {
    name: "Bath",
    id: "bath",
    aliases: ["bathtub", "s15"],
    categories: ["Web application icons"],
  },
  {
    name: "Podcast",
    id: "podcast",
    categories: ["Web application icons"],
  },
  {
    name: "Window maximize",
    id: "window-maximize",
    categories: ["Web application icons"],
  },
  {
    name: "Window minimize",
    id: "window-minimize",
    categories: ["Web application icons"],
  },
  {
    name: "Window restore",
    id: "window-restore",
    categories: ["Web application icons"],
  },
  {
    name: "Window close",
    id: "window-close",
    aliases: ["times-rectangle"],
    categories: ["Web application icons"],
  },
  {
    name: "Window close outline",
    id: "window-close-o",
    aliases: ["times-rectangle-o"],
    categories: ["Web application icons"],
  },
  {
    name: "Bandcamp",
    id: "bandcamp",
    categories: ["Brand icons"],
  },
  {
    name: "Grav",
    id: "grav",
    categories: ["Brand icons"],
  },
  {
    name: "Etsy",
    id: "etsy",
    categories: ["Brand icons"],
  },
  {
    name: "Imdb",
    id: "imdb",
    categories: ["Brand icons"],
  },
  {
    name: "Ravelry",
    id: "ravelry",
    categories: ["Brand icons"],
  },
  {
    name: "Eercast",
    id: "eercast",
    categories: ["Brand icons"],
  },
  {
    name: "Microchip",
    id: "microchip",
    categories: ["Web application icons"],
  },
  {
    name: "Snowflake outlined",
    id: "snowflake-o",
    categories: ["Web application icons"],
  },
  {
    name: "Superpowers",
    id: "superpowers",
    categories: ["Brand icons"],
  },
  {
    name: "Wpexplorer",
    id: "wpexplorer",
    categories: ["Brand icons"],
  },
  {
    name: "Meetup",
    id: "meetup",
    categories: ["Brand icons"],
  },
];

export default fontAwesomeIcons;
